import { useEffect, useState } from "react";

import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useGetElemDataById from "../../../hooks/useGetElemDataById";
import useGetUnlimitedListOf from "../../../hooks/useGetUnlimitedListOf";

const Update = ({ handleOpen, open, id }) => {
  const table = "Notifications"
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();

  const prev = useGetElemDataById(table, id,  "code");

  const [selectedmessage_code, setSelectedmessage_code] = useState();
  const [selecteduser_to_code, setSelecteduser_to_code] = useState();
  const messagesTemp = useGetUnlimitedListOf("Messages", "", "list");
  const messagesData = messagesTemp.listElements;

  const usersTemp = useGetUnlimitedListOf("Users", "", "list");
  const usersData = usersTemp.listElements;

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm();

useEffect(() => {
    if (prev) {
      if(prev.message_code) {
        setSelectedmessage_code(prev.message_code);
        setValue("message_code", prev.message_code);
      }
      if(prev.user_to_code) {
        setSelecteduser_to_code(prev.user_to_code);
        setValue("user_to_code", prev.user_to_code);
      }
    }
  }, [prev]);

  const update = async (data) => {
if (!data.message_code?.trim() || !data.user_to_code?.trim()) {
    window.alert("message_code, user_to_code non possono essere vuoti!");
    return;
  }


    const nullColumns = Object.keys(data)
    .filter(key => data[key] === null || data[key] === "")
    .join("|");

    const deletedData = data;
    delete deletedData.id;
    try {
      const updatedData = {
				code: prev.code,
        new_values: deletedData,
        str_list_null: nullColumns,
      };

      console.log(updatedData);

      const response = await axiosPrivate.put(`/${table}/update`, updatedData);
      if (response) {
        window.alert("Modifica avvenuta con successo!");
        window.location.reload();
      }
    } catch (err) {
      if (err.response?.status === 401) {
        window.location.href = "/unauthorized";
      } else {
        window.location.href = "/login";
      }
    }
  };

  if (prev.length !== 0) {
    return (
      <>

        <Modal open={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              display: "flex",
              flexDirection: "column",
            }}
            alignItems={"center"}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              sx={{ mb: 2 }}
            >
              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
              >
                Aggiorna l'elemento con id {id} alla tabella {table}
              </Typography>
              <Button
                color="error"
                onClick={() => handleOpen(false, "mod")}
                sx={{
                  maxWidth: "30px",
                  maxHeight: "30px",
                  minWidth: "30px",
                  minHeight: "30px",
                }}
              >
                <CloseIcon />
              </Button>
            </Box>
            {/* Autocomplete per il campo message_code */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={messagesData}
              getOptionLabel={(option) => option.code || ""}
              value={
                selectedmessage_code
                  ? messagesData.find((comunication) => comunication.code === selectedmessage_code)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedmessage_code(newValue.code);
                  setValue("message_code", newValue.code);
                } else {
                  setSelectedmessage_code(null);
                  setValue("message_code", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select message_code"
                  placeholder="message_code"
                  error={!!errors.message_code}
                  helperText={
                    errors.message_code ? "Il campo message_code è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
            {/* Autocomplete per il campo user_to_code */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={usersData}
              getOptionLabel={(option) => option.code || ""}
              value={
                selecteduser_to_code
                  ? usersData.find((user) => user.code === selecteduser_to_code)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelecteduser_to_code(newValue.code);
                  setValue("user_to_code", newValue.code);
                } else {
                  setSelecteduser_to_code(null);
                  setValue("user_to_code", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select user_to_code"
                  placeholder="user_to_code"
                  error={!!errors.user_to_code}
                  helperText={
                    errors.user_to_code ? "Il campo user_to_code è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
						{Object.entries(prev)
              .filter(([key]) => true && key !== "code" && key !== "message_code" && key !== "user_to_code" && key !== "read")
              .map(([key, value], index) => (
                <TextField
                  key={index}
                  placeholder={key}
                  defaultValue={value}
                  sx={{ width: "50%", m: 1 }}
                  {...register(key)}
                />
              ))}
{/* switch per campo read */}
<Controller
      name="read"
      control={control}
      defaultValue={prev.read}
      render={({ field }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography sx={{ mr: 2 }}>read:</Typography>
          <Switch color="primary" {...field} checked={field.value} />
        </Box>
      )}
    />

            <Button onClick={handleSubmit(update)}>SALVA MODIFICHE</Button>
          </Box>
        </Modal>
      </>
    );
  }
};

export default Update;